export enum FeedType {
  ForYou = "ForYou",
  User = "User",
  Game = "Game",
}
